module.exports = __webpack_public_path__ + "static/media/Formular-Light.32545091.otf";